<style lang="scss" scoped>
    .pre {
        white-space: pre-line;
    }
    .confidence-bar {
        width: 400px;
    }
</style>
<template>
    <base-dialog
        v-model="isDialogOpen"
        :on-cancel="doClose"
        :on-close="doClose"
        :min-width="776"
        :max-width="776">
        <template #title>
            <div class="font-weight-light text-h4 pb-6">
                {{ $t('copilot.evaluationResult') }}
            </div>
        </template>
        <template #body>
            <v-progress-linear
                v-if="result?.confidence"
                class="confidence-bar mb-4"
                :value="confidencePercent"
                :color="confidenceColor"
                height="25">
                <strong>{{ $t('copilot.goldenSqlSimilarityScore') }}: {{ result?.confidence }}</strong>
            </v-progress-linear>
            <template v-if="result?.goldenSqlSimilarity || result?.llmAsAJudge">
                <h6 class="text-h6 mb-1">
                    {{ $t('copilot.semanticConformance') }}
                </h6>
                <p class="pre">
                    {{ result?.goldenSqlSimilarity || '--' }}
                </p>

                <h6 class="text-h6 mb-1">
                    {{ $t('copilot.llmAsJudge') }}
                </h6>
                <p class="pre">
                    {{ result?.llmAsAJudge || '--' }}
                </p>
            </template>
            <template v-else>
                <h6 class="text-h6 mb-1">
                    {{ $t('copilot.evaluationRemark') }}
                </h6>
                <p class="pre">
                    {{ result?.reason || '--' }}
                </p>

                <h6 class="text-h6 mb-1">
                    {{ $t('copilot.analysisByLLM') }}
                </h6>
                <p class="pre">
                    {{ result?.responseAnalysis || '--' }}
                </p>
            </template>
        </template>
        <template #actions="{ cancel }">
            <v-spacer />
            <v-btn
                color="primary"
                class="cancel"
                depressed
                rounded
                @click="cancel">
                <span class="text-none"> {{ $t('ok') }}</span>
            </v-btn>
        </template>
    </base-dialog>
</template>
<script>
    export default {
        name: 'EvaluationResultModal',
        props: {
            result: {
                type: Object,
                required: true,
            },
        },
        data() {
            return {
                isDialogOpen: false,
            }
        },
        computed: {
            confidencePercent() {
                return (this.result?.confidence || 0) * 2 * 10
            },
            confidenceColor() {
                let color = 'success'
                if (this.result?.confidence <= 2) color = 'orange'
                else if (this.result?.confidence === 3) color = 'lime'
                return color
            },
        },
        methods: {
            open() {
                this.isDialogOpen = true
            },
            doClose() {
                this.isDialogOpen = false
            },
        },
    }
</script>
